import { render } from "./common.vue?vue&type=template&id=f082be4e&scoped=true"
import script from "./common.vue?vue&type=script&lang=js"
export * from "./common.vue?vue&type=script&lang=js"

import "./common.vue?vue&type=style&index=0&id=f082be4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f082be4e"]])

export default __exports__